var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded aha-banner-success flex items-center justify-center"},[_c('div',{staticClass:"inline-flex justify-center items-center p-2"},[_c('TickSvg',{staticClass:"flex-shrink-0 mr-1 aha-success-icon",attrs:{"color":'#33C173'}}),_c('span',{staticClass:"text-base text-secondary-100"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }